// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3aqX1","imageUploader":"EGiftCard_imageUploader__3fv3s"};